import { ICP_ICP_ID, USDC_ARB_ID, USDC_HYPERCORE_SPOT_ID, USDC_ICP_ID } from './tokenIds'

export const SWAP_COMMISSION = 0.005
export const CYCLES_MINT_COMISSION = 0.05
export const HYPERLIQUID_COMISSION = 50
const SWAP_PROVIDER_COMMISSION = 0.003

export const SWAP_COMMISSION_TOTAL = SWAP_COMMISSION + SWAP_PROVIDER_COMMISSION

export const STAKE_COMMISSION = 0.01

export const COMMISSIONS_WALLETS = [
  'cxzp7-t526w-ggqn4-jbd65-jtaqg-kf7gr-jaxmm-3fiol-fsx5u-r4fth-lae',
  'jpish-ddmau-bafpv-mwr3k-6yuxy-acyde-t2y6y-nufkx-soodd-gzfhh-uae',
  '24kee-axza3-dh4t3-vdsot-7ezgb-xlndz-4ei3x-5aurb-cogij-dr4dm-wae',
  'ujimm-o7e25-jk74t-ivcjb-frqvz-ozqqp-hsv3f-beg4c-nw4p6-kgp3r-4ae',
]

export const SOL_COMMISSION_WALLET = '6pigPkp6bWLsmvdRBtwa6GUWVi5u6Rjxd1HCb1XhWpD3'
export const ETH_COMISSION_WALLET = '0xb2fed3acf6e30e0f1902a2b190c88c9a0a68edc3'

export const SWAP_COMMISSION_MEMO = 1337
export const STAKE_COMMISSION_MEMO = 1338
export const CYCLE_MINT_COMISSIONS_MEMO = 1339

export const BASE_CHAIN_ID = 8453
export const ARB_CHAIN_ID = 42161
export const ETH_CHAIN_ID = 1
export const BNB_CHAIN_ID = 56
export const HYPEREVM_CHAIN_ID = 999

export const DEFAULT_L1_CHAINS = ['icp', 'odin', 'sol', 'btc', 'doge']

export const UTXO_CHAINS = ['btc', 'doge', 'ltc'] as const

// Source tokens that can fund the HyperCore perp account via Swap.
export const PERP_FUNDING_SOURCE_IDS = [
  ICP_ICP_ID,
  USDC_ICP_ID,
  USDC_ARB_ID,
  USDC_HYPERCORE_SPOT_ID,
]
